<div class="modal-header">
  <h5 class="modal-title"><i class="far fa-box-up"></i> {{ dialogTitle }}</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="description">
    Specify an absolute or percentage adjustment which should be made for rates pushed to a specific channel. This
    adjustment is only applied to Tokeet generated channel rates and not to rate categories you create. Channel
    adjustments will cause the default rate to be pushed to your connected API channels, even if your rate mapping
    specifies a different rate category to be pushed.
  </div>

  <form [formGroup]="form" (submit)="onSubmit(form)" [formEditablePermission]="form">
    <div class="row">
      <div class="col-12">
        <app-select-search
          bindValue="id"
          bindLabel="friendlyName"
          [items]="channels$ | async"
          [ctrl]="form.get('channelId')"
          [multiple]="false"
          placeholder="Select Channel"
          matTooltip="Select a channel to adjust."
          matTooltipPosition="above"
          matTooltipClass="text-center"
        >
          <ng-container class="error-container">
            <mat-error *ngIf="form.get('channelId').touched && form.get('channelId').hasError('required')">
              Channel is <strong>required</strong>
            </mat-error>
          </ng-container>
        </app-select-search>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-select-search
          bindValue="id"
          bindLabel="name"
          [items]="filteredRentals$ | async"
          [ctrl]="form.get('rentalIds')"
          placeholder="Select Rentals"
          matTooltip="Select rentals to adjust"
          matTooltipPosition="above"
          matTooltipClass="text-center"
        >
          <ng-container class="error-container">
            <mat-error *ngIf="form.get('rentalIds').touched && form.get('rentalIds').hasError('required')">
              Rentals are <strong>required</strong>
            </mat-error>
          </ng-container>
        </app-select-search>
      </div>
    </div>

    <mat-radio-group [name]="adjustType" formControlName="adjustType">
      <div class="row">
        <div class="col-sm-6">
          <div class="adjust-container">
            <mat-radio-button [name]="adjustType" value="amount"></mat-radio-button>
            <mat-form-field class="mat-block">
              <input
                type="number"
                matInput
                [required]="adjustType === 'amount'"
                placeholder="Adjust Amount"
                formControlName="adjustAmount"
                tabindex="3"
              />
              <mat-error *ngIf="form.get('adjustAmount').touched && form.get('adjustAmount').hasError('required')">
                Value is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="adjust-container">
            <mat-radio-button [name]="adjustType" value="percent"></mat-radio-button>
            <mat-form-field class="mat-block">
              <input
                type="number"
                matInput
                [required]="adjustType === 'percent'"
                placeholder="Adjust Percent (%)"
                formControlName="adjustPercent"
                tabindex="5"
              />
              <mat-error *ngIf="form.get('adjustPercent').touched && form.get('adjustPercent').hasError('required')">
                Value is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-radio-group>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase" tabindex="202">
    <i class="fal fa-times"></i> Cancel
  </button>
  <button
    (click)="onSubmit(form)"
    [disabled]="form.disabled || (1 | isReadonlyRole)"
    type="button"
    class="btn btn-success text-uppercase create-btn"
    tabindex="201"
  >
    <i *ngIf="!form.disabled" class="fal fa-save"></i>
    <i *ngIf="form.disabled" class="fal fa-spinner fa-spin"></i>
    Save
  </button>
</div>
